import store from 'basic-store';

export default store({
	merchandise: {},
});